module.exports = __webpack_public_path__ + "static/media/top-soil-interreg-nsr-horizontal.c5da8902.png";